import { NavLink, useLocation } from 'react-router-dom';
import { SidebarMenuDTO } from '../../types/sidebar';
import SvgIcon from '../SvgIcon/SvgIcon';

/**
 * 📄 SidebarMenuLinkV2
 *
 * Todos los menús son independientes.
 *
 * ✅ Solo se marca activo si coincide EXACTAMENTE
 * ✅ Ya no usamos startsWith()
 * ✅ Evita dobles selecciones visuales
 *
 * Ejemplo:
 *
 * /marketing/promotions
 * ≠
 * /marketing/promotions/editor
 */
const SidebarMenuLinkV2: React.FC<{ menu: SidebarMenuDTO }> = ({ menu }) => {
  const { pathname } = useLocation();
  const isDisabled = !menu.route;

  /**
   * 🔥 Match exacto solamente
   */
  const isActive = !!menu.route && pathname === menu.route;

  const baseClass =
    'relative flex items-center gap-2 rounded-md px-3 py-2 text-sm font-medium transition-all duration-300 ease-in-out hover:pl-4';

  const activeStyles =
    'text-white bg-graydark before:absolute before:left-0 before:top-0 before:h-full before:w-1 before:bg-primary before:rounded-r-md before:shadow-[0_0_6px_rgba(59,130,246,0.8)]';

  const content = (
    <div
      className={`${baseClass} ${
        isDisabled
          ? 'text-gray-500 cursor-not-allowed opacity-50'
          : isActive
          ? activeStyles
          : 'text-gray-300 hover:bg-graydark/60 hover:text-white'
      }`}
    >
      {menu.icon && <SvgIcon name={menu.icon as any} className="h-4 w-4 shrink-0" />}
      {menu.name}
    </div>
  );

  if (isDisabled) {
    return <div>{content}</div>;
  }

  return (
    <NavLink to={menu.route!} className="block">
      {content}
    </NavLink>
  );
};

export default SidebarMenuLinkV2;
